import { atom, useAtom } from 'jotai'

export const recruitmentTotalAtom = atom<number | undefined>(undefined)

export const useRecruitmentTotal = () => {
    const [recruitmentTotal, setRecruitmentTotal] = useAtom(recruitmentTotalAtom)

    return { recruitmentTotal, setRecruitmentTotal }
}
